export const getRowKey = (part) => `${part.orderPartId}_${part.partId}_${part.serial || "NOSERIAL"}_${part.dimensionInfo?.id || "NODIMENSION"}`;

/**
 * @param {Array} orderParts
 * @param {Array} orderDimensions
 * @param {Record<string, number|null|undefined>} partNoIdMap
 * @param {Record<string, Array>} availableDimensionsByPartId
 * @returns {Array}
 */
export const buildMergedOrderParts = (orderParts, orderDimensions, partNoIdMap = {}, availableDimensionsByPartId = {}) => {
    const res = [];
    for (const orderPart of orderParts ?? []) {
        const serialized = orderPart.isSerialized;
        const partId = partNoIdMap[orderPart.partNo];
        if (!serialized) {
            const dimension = orderDimensions?.find(part => part.orderPartId === orderPart.id && !part.serialNumber);
            res.push({
                orderPartId: orderPart.id,
                partId: partId,
                partNo: orderPart.partNo,
                serial: undefined,
                qty: Number(orderPart.committedQty ?? "0"),
                dimensionInfo: dimension,
                availableDimensions: partId ? availableDimensionsByPartId[partId] : undefined,
            });
        } else {
            for (const serial of orderPart.serials ?? []) {
                const dimension = orderDimensions?.find(part => part.orderPartId === orderPart.id && part.serialNumber === serial?.serialNumber);
                res.push({
                    orderPartId: orderPart.id,
                    partId: partId,
                    partNo: orderPart.partNo,
                    serial: serial?.serialNumber,
                    qty: 1,
                    dimensionInfo: dimension,
                    availableDimensions: partId ? availableDimensionsByPartId[partId] : undefined,
                });
            }
        }
    }
    return res;
};

/**
 * @param {Array} containers
 * @param {Array} mergedParts
 * @returns {Array}
 */
export const computeContainerWeightMetrics = (containers, mergedParts) => {
    return containers?.map(container => {
        const assignedParts = mergedParts?.filter(part => part.dimensionInfo?.orderPalletId === container.id) ?? [];
        const grossWeight = assignedParts.reduce((sum, part) => {
            if (part.dimensionInfo?.weight) {
                return sum + (part.dimensionInfo.weight * part.qty);
            }
            return sum;
        }, 0);
        const hasImputedWeight = !assignedParts.length || assignedParts.some(part => !part.dimensionInfo?.weight);
        return {
            ...container,
            grossWeight,
            hasImputedWeight,
        };
    }) ?? [];
};
